import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/shared/services/api/api.service';
import {
  ImpactSummaries,
  SetImpactSummaries,
  ShareISPost,
} from './interfaces/impact-summaries.interface';
import { UsersByJobRole } from './interfaces/users-by-job-role.interface';
import { ImpactUserInvitation } from './interfaces/impact-user-invitation';
import { StorageService } from '../../../shared/services/storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class ImpactSummariesService {
  constructor(private api: ApiService, private storage: StorageService) {}

  getImpactSummaries(): Observable<ImpactSummaries> {
    const url = 'impact_summary/get-impact-summaries/';
    return this.api.get(url);
  }

  getNewLabel(data): Observable<SetImpactSummaries> {
    const url = 'impact_summary/set-impact-summaries-new-label/';
    return this.api.post(url, data);
  }

  getUsersByJobRole(): Observable<UsersByJobRole> {
    const url = '/organization/get-users-by-job-role/';
    return this.api.get(url);
  }

  getUsersShare(): Observable<any> {
    const url = '/impact_summary/users/';
    return this.api.get(url);
  }

  sendShareIS(data: ShareISPost): Observable<ShareISPost> {
    const url = '/impact_summary/share/';
    return this.api.post(url, data);
  }

  sendViewerInvite(
    email: string,
    job_role: string
  ): Observable<ImpactUserInvitation> {
    const url = 'organization/invite-report-viewer';
    return this.api.post(url, { email, job_role });
  }

  saveAccessPoint(type: string): void {
    this.storage.setImpactSummariesAccessPoint(type);
  }

  getAccessPoint(): string {
    return this.storage.getImpactSummariesAccessPoint();
  }
}
